
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, HistoryCriteria, IActionCriteria, IInvoiceSummaryViewModel, IVendorPaymentSummaryViewModel, MetadataAction, VendorChartViewModel, VendorViewModel } from "@tylertech/tyler-api-types";

/**
 * VendorService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class VendorService {
    constructor(private readonly $apiService: ApiService) { }
    
    GetChartData(pVendorId: string): Promise<ExecutionResult<VendorChartViewModel>> {
        return this.$apiService.sendAuth("IVendorService/GetChartData", pVendorId);
    }
    GetNewVendorMetadataAction(): Promise<MetadataAction> {
        return this.$apiService.sendAuth("IVendorService/GetNewVendorMetadataAction");
    }
    GetStatusTypes(): Promise<string[]> {
        return this.$apiService.sendAuth("IVendorService/GetStatusTypes");
    }
    GetVendor(pVendorId: string): Promise<ExecutionResult<VendorViewModel>> {
        return this.$apiService.sendAuth("IVendorService/GetVendor", pVendorId);
    }
    GetVendorInvoiceHistory(criteria: HistoryCriteria): Promise<IInvoiceSummaryViewModel[]> {
        return this.$apiService.sendAuth("IVendorService/GetVendorInvoiceHistory", criteria);
    }
    GetVendorPaymentHistory(criteria: HistoryCriteria): Promise<IVendorPaymentSummaryViewModel[]> {
        return this.$apiService.sendAuth("IVendorService/GetVendorPaymentHistory", criteria);
    }
    IsEditable(): Promise<boolean> {
        return this.$apiService.sendAuth("IVendorService/IsEditable");
    }
    PerformAction(pCriteria: IActionCriteria): Promise<any> {
        return this.$apiService.sendAuth("IVendorService/PerformAction", pCriteria);
    }
    UpdateVendor(vendor: VendorViewModel): Promise<ExecutionResult<any>> {
        return this.$apiService.sendAuth("IVendorService/UpdateVendor", vendor);
    }
    VendorHasBid(pVendorId: string): Promise<boolean> {
        return this.$apiService.sendAuth("IVendorService/VendorHasBid", pVendorId);
    }
}
